export type VimeoUrlParams = {
  loop?: '1' | '0' | 0 | 1;
  autoplay?: '1' | '0' | 0 | 1;
  colors?: string;
};

export function constructVimeoUrlFromVideoId(videoId?: string, params: VimeoUrlParams = {}) {
  if (!videoId) return null;
  const url = new URL(`https://player.vimeo.com/video/${videoId}`);
  Object.keys(params).forEach((key) => url.searchParams.append(key, String(params[key as keyof VimeoUrlParams])));
  return url.toString();
}

export function formatVideoTime(seconds?: number): string | undefined {
  if (!seconds) return;
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  const formattedMinutes = minutes > 0 ? String(minutes) : '00';
  const formattedSeconds = String(remainingSeconds).padStart(2, '0');

  return `${formattedMinutes}:${formattedSeconds}`;
}
